import { render } from "./api.vue?vue&type=template&id=e35d9e98&scoped=true"
import script from "./api.vue?vue&type=script&lang=js"
export * from "./api.vue?vue&type=script&lang=js"

import "./api.vue?vue&type=style&index=0&id=e35d9e98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e35d9e98"]])

export default __exports__